import Vue from 'vue'
import DaysWorker from 'worker-loader?name=days.worker.js!./days.worker.js'
import TimesWorker from 'worker-loader?name=times.worker.js!./times.worker.js'
import PromiseWorker from '@/utils/PromiseWorker'
import { get, post, del } from '@/api'

export default {
  namespaced: true,
  state: {
    available_times: null,
    available_days: null,
    bookings: []
  },
  mutations: {
    SET_AVAILABLE_TIMES(state, times) {
      Vue.set(state, 'available_times', times)
    },

    SET_AVAILABLE_DAYS(state, days) {
      state.available_days = days
    },

    SET(state, booking) {
      const existingBooking = state.bookings.find(activeBooking => activeBooking.id === booking.id)

      if (existingBooking) {
        state.bookings.splice(state.bookings.indexOf(existingBooking), 1, booking)
      } else {
        state.bookings.push(booking)
      }
    },

    UNSET(state, bookingToken) {
      const booking = state.bookings.find(booking => booking.token === bookingToken)

      if (booking) {
        const index = state.bookings.indexOf(booking)
        state.bookings.splice(index, 1)
      }
    }
  },
  actions: {
    async COMPUTE_AVAILABLE_DAYS({ commit }) {
      const worker = new PromiseWorker(new DaysWorker())
      const result = await worker.postMessage(365 / 2)
      commit('SET_AVAILABLE_DAYS', result)
    },

    async FETCH_AVAILABLE_TIMES({ commit, state }, { restaurant, date, guests }) {
      const currentAvailableTimes = state.available_times

      try {
        const json = await get(
          `restaurants/${restaurant.pos_id}/available-times/${date}?number_of_guests=${guests}`
        )
        const worker = new PromiseWorker(new TimesWorker())
        const timesPadded = await worker.postMessage(json.data.available_times)
        commit('SET_AVAILABLE_TIMES', timesPadded)

        return timesPadded
      } catch (error) {
        commit('SET_AVAILABLE_TIMES', currentAvailableTimes)
        throw error
      }
    },

    async CANCEL({ commit, dispatch }, bookingToken) {
      try {
        const json = await del(`table-bookings/${bookingToken}`)
        dispatch('FORGET_TOKENS', bookingToken, { root: true })
        commit('UNSET', bookingToken)
        return json
      } catch (error) {
        throw error
      }
    },

    async CREATE(
      { commit, dispatch },
      { restaurant, guests, date, time, name, phone, email, comment, newsletter }
    ) {
      const body = JSON.stringify({
        restaurant_id: restaurant.id,
        name,
        phone,
        email,
        number_of_guests: guests,
        starts_at: `${date} ${time}:00`,
        comment,
        newsletter,
        utm_source: window.sessionStorage.getItem('app/utm_source') || undefined,
        utm_medium: window.sessionStorage.getItem('app/utm_medium') || undefined,
        utm_campaign: window.sessionStorage.getItem('app/utm_campaign') || undefined,
        utm_term: window.sessionStorage.getItem('app/utm_term') || undefined,
        utm_content: window.sessionStorage.getItem('app/utm_content') || undefined
      })

      try {
        const json = await post(`table-bookings`, { body })
        const booking = json.data.table_booking

        commit('SET', booking)
        dispatch(
          'REMEMBER_TOKENS',
          {
            bookingToken: booking.token,
            orderToken: booking.order_token
          },
          { root: true }
        )

        return booking
      } catch (error) {
        throw error
      }
    },

    async FETCH({ dispatch, commit }, bookingToken) {
      try {
        const json = await get(`table-bookings/${bookingToken}`)
        const booking = json.data.table_booking

        if (booking.is_in_the_past) {
          dispatch('FORGET_TOKENS', bookingToken, { root: true })
        } else {
          commit('SET', booking)
          dispatch(
            'REMEMBER_TOKENS',
            { bookingToken: booking.token, orderToken: booking.order_token },
            { root: true }
          )
        }

        return booking
      } catch (error) {
        if (error.status === 404) {
          dispatch('FORGET_TOKENS', bookingToken, { root: true })
        }

        throw error
      }
    },

    async FETCH_PREORDERS({ dispatch, commit }, bookingToken) {
      try {
        const json = await get(`table-bookings/${bookingToken}/order`)
        const order = json.data.order

        commit('order/REPLACE', { order, orderToken: order.token }, { root: true })

        return order
      } catch (error) {
        if (error.status === 404) {
          dispatch('FORGET_TOKENS', bookingToken, { root: true })
        }

        throw error
      }
    }
  },
  getters: {}
}
